import {Button, Text} from "@wakelet/ui-kit";
import {AppleSSO, ClasslinkSSO, CleverSSO, FacebookSSO, GoogleSSO, MicrosoftSSO} from "../sso/SsoButtons";
import {Link} from "react-router-dom";
import {translateKey} from "../language/translate";
import {isDev} from "../../env/env";
import {gaLoginLinkClicked} from "../../analytics/ga";

export const SignUpContent = () => {
  return (
    <div className="flex flex-col items-center min-h-[500px]">
      <div className="flex flex-col items-center mb-8">
        <img
          className="content-center mb-8 w-[114px] h-[27px]"
          src="https://assets.wakelet.com/logo/wklt-blue.svg"
          data-testid="login-form-logo"
          alt="wakelet"
        />
        <Text.Heading level={3}>{translateKey("account:signup.title")}</Text.Heading>
      </div>

      <div className="flex flex-col items-center">
        <AppleSSO/>
        <GoogleSSO/>
        <MicrosoftSSO/>
        <FacebookSSO/>
        {isDev() && <ClasslinkSSO/>}
        <CleverSSO/>
      </div>

      <Text>{translateKey("account:or")}</Text>

      <div className="flex flex-col items-center mt-2">

        <div className="w-80">
          <Button.Style block>
            <Link to="/sign-up/email"
                  data-testid="email-signup-btn"
                  data-id="email-signup"
                  className="w-full text-center">
              <Button.Label text={translateKey("account:signup.email.button")}/>
            </Link>
          </Button.Style>
        </div>

        <div className="my-4 text-center" data-testid={"signup-agreement"}>
          <Text>
            {translateKey("account:signup.agreementShort", {wakelet: "Wakelet"})}{" "}
            <span className="font-semibold hover:underline">
                <a data-id="terms" href="https://wakelet.com/terms.html">{translateKey("account:signup.terms")}</a>
              </span>,{" "}
            <span className="font-semibold hover:underline">
                <a data-id="privacy"
                   href="https://wakelet.com/privacy.html">{translateKey("account:signup.privacy")}</a>
              </span>{" "}
            {translateKey("account:and")}{" "}
            <span className="font-semibold hover:underline">
                <a data-id="rules" href="https://wakelet.com/rules.html">{translateKey("account:signup.rules")}</a>
              </span>.
          </Text>
        </div>
        <Text className="mb-5" data-testid={"login-action"}>
          {translateKey("account:signup.loginAction")}{" "}
          <Link to="/login" className="!text-blue-700 !font-bold"
                onClick={() => gaLoginLinkClicked("page_get_started")}
          >
            {translateKey("common:buttons.login")}
          </Link>.
        </Text>
      </div>

    </div>
  );
};
